// extracted by mini-css-extract-plugin
export default {"wrapper":"Pay_wrapper__mbvfd","header":"Pay_header__D6YR7","goBack":"Pay_goBack__AvoF0","container":"Pay_container__wZy+u"};